<template>
  <div id="messages">
    <v-container class="pa-0" v-if="!session.getSession().adminUser">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute right @click="messageAddPage" class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>       
    </v-container>
    <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search by From / To / Subject"
          hide-details
        ></v-text-field>
    </v-card-title>
    <div class="text-xs-left">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            color="teal"
            dark
            small
            flat
            v-on="on"
          >
            <span><b>SortBy:</b> {{ sortMessagesBy }}</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in sortBy"
            :key="index"
            @click="sortMessage(item)"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <v-card class="mt-3">
      <v-tabs class="xs12" style="width:100%" hide-slider grow>
        <v-tabs-slider color="#019d8c"></v-tabs-slider>
          <v-tab v-for="type of listType" :key="type" class="justify-space-around" @click="getItems(type)">
              {{type}}
          </v-tab>
        <v-tab-item transition="slide-x-transition" reverse-transition="slide-x-transition"
      v-for="i in listType.length"
      :key="i">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search" 
        :pagination.sync="pagination"
        :loading="loading_message"
        light
        hide-headers
      >
        <template v-slot:items="props" class="rows">
         <tr 
         v-if="(props.item.groups && props.item.groups.length) || (props.item.human && props.item.human.length > 1)"
         :class="(props.item.last_message && props.item.last_message.is_seen === false && props.item.last_message.createdBy !== session.user().id) ? 'unread-row' : 'read-row'">
          <td class="pa-1" width="20px">
            <v-avatar class="teal mx-1" size="36" v-if="props.item.last_message && props.item.last_message.human && props.item.last_message.human.account">
              <img class="white" v-if="(props.item.last_message.human.account.avatar ? props.item.last_message.human.account.avatar : (session.role() === 'parent') ? Account.avatar : Agency.avatar) !== ''" :src="[props.item.last_message.human.account.avatar ? props.item.last_message.human.account.avatar : (session.role() === 'parent') ? Account.avatar : Agency.avatar]" alt="">
              <span v-else class="white--text subheading">
                  {{ session.user().id === props.item.last_message.createdBy ? (session.role() === 'parent') ? Account.name.substr(0,2) : Agency.name.substr(0,2) : props.item.last_message.human.account.name.substr(0,2) }}
              </span>
            </v-avatar>
            <v-avatar class="teal mx-1" size="36" v-if="props.item.last_message && props.item.last_message.human && props.item.last_message.human.agency">
              <img class="white" v-if="(props.item.last_message.human.agency.avatar ? props.item.last_message.human.agency.avatar : '') !== ''" :src="props.item.last_message.human.agency.avatar" alt="">
              <span v-else class="white--text subheading">
                  {{ session.user().id === props.item.last_message.createdBy ? (session.role() === 'parent') ? Account.name.substr(0,2) : Agency.name.substr(0,2) : props.item.last_message.human.agency.name.substr(0,2) }}
              </span>
            </v-avatar>
            <v-avatar class="teal mx-1" size="36" v-if="!props.item.last_message || props.item.last_message.human === null">
              <span class="white--text subheading">
                {{ props.item.human[props.item.human.length -1].display_name.substr(0, 2) }}
              </span>
            </v-avatar>
          </td>
            <td :class="currentTab === 'Inbox' ? 'pl-2 pointer': 'pl-2'" @click="currentTab === 'Inbox'? replyMessage(props.item) : ''">
            <span class="messageSubject">
              <v-tooltip top class="unReadList" v-if="(props.item.last_message && props.item.last_message.is_seen === false && props.item.last_message.createdBy !== session.user().id)">
                <v-icon small color="blue lighten-3" slot="activator">
                  fas fa-circle
                </v-icon>
                <span>Unread message</span>
              </v-tooltip>
              <span class="messageNames">
                <template v-for="(item, index) in props.item.human">
                  {{ props.item.human.length > index + 1 ? item.display_name + ',' : item.display_name }} 
                </template>
              </span>
            </span>
            <span>
              {{ props.item.subject }}
            </span>
            <span class="messageContent" v-if="props.item.last_message">
              
              {{ removeHTML(props.item.last_message.content) }}
            </span>
          </td>
          <td class="text-xs-right py-0" width="160px">
            <span>{{ moment.tz((new Date(props.item.updatedAt)).toISOString(), moment.tz.guess()).fromNow()}}</span>
          </td>
          <td align="right" width="150px" v-if="currentTab === 'Inbox'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon class="ma-0" @click="replyMessage(props.item)" small>
                <v-icon size="22" color="grey darken-2" >reply</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Reply</span>
            </v-tooltip>
            <v-tooltip top v-if="!session.getSession().adminUser">
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon class="ma-0" @click="archItem(props.item)" small>
                <v-icon size="22" color="grey darken-2" >archive</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Archive</span>
            </v-tooltip>
            <v-tooltip top v-if="!session.getSession().adminUser">
              <template v-slot:activator="{ on }">
              <span v-on="on">
                <v-btn icon class="ma-0" @click="delItem(props.item)" small>
                <v-icon size="22" color="grey darken-2" >delete_outline</v-icon>
                </v-btn>
              </span>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </td>
         </tr>
        </template>
      </v-data-table>
       </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
/* global session router store config */
import swal from 'sweetalert2';
import { getCollection, remove, formatDate, update, conversationListPopulate } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
export default {
  data: () => ({
    entity: 'Message',
    conversationEntity: 'Conversation',
    loading_message: false,
    search: '',
    list: [],
    listType: ['Inbox', 'Archive'],
    currentTab: 'Inbox',
    pagination: {
      sortBy: 'last_message.updatedAt', // The field that you're sorting by
      descending: true,
      rowsPerPage: config.dom.rowsPerPage
    },
    headers: [
      { text: 'From/To', value: 'human[0].display_name' },
      { text: 'Subject', value: 'subject' },
      { text: 'Created Date', value: 'date' },
      { text: 'Last message', value: 'updatedAt', align: 'center' },
    ],
    agencyFamiliesList: [],
    agencyAdminList: [],
    sortBy: [
      { title: 'Date', value: 'last_message.updatedAt' },
      { title: 'Created Date', value: 'createdAt' },
      { title: 'Name', value: 'human[0].display_name' },
      { title: 'Subject', value: 'subject' },
    ],
    sortMessagesBy: 'Date'
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency', 'Account', 'Message']),
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    },
    ArchiveConversation: {
      get () {
        return store.state.ArchiveConversation;
      },
      set (value) {
        store.commit('setArchiveConversation', value);
      }
    },
    ContactList: {
      get () {
        return store.state.ContactList;
      },
      set (value) {
        store.commit('setContactList', value);
      }
    }
  },
  watch: {
    Conversation (value) {
      this.Conversation = value;
    }
  },
  async created () {
    if (session.isOnline()) {
      this.role = session.getSession().user.role;
    }
    if (!this.Conversation.length) await this.initialize('inbox');
    if (!this.ArchiveConversation.length) await this.initialize('archive');
    await this.getItems('Inbox');
  },
  methods: {
    async archItem (item) {
      let sessionUser = session.getSession();
      let Conversation = JSON.parse(JSON.stringify(item));
      Conversation.archive.push(sessionUser.user.human.id);
      Conversation.last_message = Conversation.last_message.id;
      Conversation.human = Array.from(Conversation.human, human => human.id);
      Conversation.groups = Array.from(Conversation.groups, group => group.id);
      Conversation.message = Conversation.message.map(message => {
        return { _id: message._id, message: message.message.id };
      });
      let { error, data, status } = await update('Conversation', Conversation, Conversation.id);
      if (error) {
        console.log('error', error);
      } else {
        data.last_message = item.last_message;
        data.human = item.human;
        data.groups = item.groups;
        data.message = item.message;
        const index = this.Conversation.indexOf(item);
        this.Conversation.splice(index, 1);
        this.ArchiveConversation.push(data);
        swal.fire({
          type: 'success',
          title: `Conversation moved to Archive Successfully`,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    },
    async delItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let sessionUser = session.getSession();
            let Conversation = JSON.parse(JSON.stringify(item));
            Conversation.removed.push(sessionUser.user.human.id);
            Conversation.last_message = Conversation.last_message.id;
            Conversation.human = Array.from(Conversation.human, human => human.id);
            Conversation.groups = Array.from(Conversation.groups, group => group.id);
            Conversation.message = Conversation.message.map(message => {
              return { _id: message._id, message: message.message.id };
            });
            let { error, data, status } = await update('Conversation', Conversation, Conversation.id);
            if (error) {
              console.log('error', error);
            } else {
              const index = this.Conversation.indexOf(item);
              this.Conversation.splice(index, 1);
              swal.fire({
                type: 'success',
                title: `Conversation deleted Successfully`,
                showConfirmButton: false,
                timer: 2500,
              });
            }
          })();
        }
      });
    },
    getItems (type) {
      if (type === 'Inbox') {
        this.currentTab = 'Inbox';
        this.list = this.Conversation;
      } else {
        this.currentTab = 'Archive';
        this.list = this.ArchiveConversation;
      }
    },
    messageAddPage () {
      this.$router.push({ name: 'addMessage', query: { preUrl: 'Messages' }});
    },
    async initialize (type) {
      this.loading_message = true;
      let sort = { 'updatedAt': -1 };
      let sessionUser = session.getSession();
      let where = {};
      let inboxObj =  {
        $or: [
          {
            archive: { $exists: false }
          },
          {
            archive: {
              $ne: sessionUser.user.human.id
            }
          }
        ]
      };
      let archiveObj =  {
        $and: [{ archive: { $exists: true }}, {
          archive: sessionUser.user.human.id
        }]
      };
      where = {
        $and: [
          {
            $or: [
              {
                human: sessionUser.user.human.id
              }
            ]
          },
          {
            $or: [
              {
                removed: { $exists: false }
              },
              {
                removed: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          }
        ]
      };
      type === 'inbox' ? where.$and.push(inboxObj) : where.$and.push(archiveObj);
      if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
        where.$and[0].$or.push({
          groups: {
            $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
          }
        });
      }
      let { error, data } = await getCollection(this.conversationEntity, true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          type === 'inbox' ? this.Conversation = data : this.ArchiveConversation = data;
        }
        this.loading_message = false;
      }
    },
    replyMessage (item) {
      this.$router.push({ 'path': '/message/reply/' + item.id });
    },
    formatDate (dateString, format) {
      return formatDate(dateString, format);
    },
    removeHTML (text) {
      let strippedText = text.replace(/(<([^>]+)>)/ig, '');
      strippedText = strippedText.substr(0, 140) + ' ...';
      return strippedText;
    },
    
    sortMessage (item) {
      console.log(this.sortMessagesBy === item.title);
      this.pagination.descending = !this.pagination.descending;
      this.sortMessagesBy = item.title;
      this.pagination.sortBy = item.value;
    }
  }
};
</script>
<style scoped>
 .unread-row td{
  font-weight: 800;
 }
 .messageDate, .messageContent {
  display: block;    
  color: #9e9e9e;
  font-size: 12px;
 }
 .messageNames{
   color: rgba(0,0,0,0.87);
 }
 .messageNames, .messageContent {
  font-size: 14px;
 }
 .messageSubject {
   display: block;
   font-size: 15px;
 }

.unReadList {
  /* position: absolute;
  right: 0px;
  padding: 15px 10px; */
  vertical-align: text-bottom;
}
.unReadList .v-icon{
  font-size: 10px !important;
 }
 .message-avatar {
   width: 20px !important;
   padding: 0px 10px !important;
 }
.pointer {
   cursor: pointer;
}
#messages >>> .v-tabs__item--active {
  background: #319d8c !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Messages/list.vue